import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ComponentFactoryResolver,
  OnDestroy,
  ViewChild,
  HostBinding,
} from '@angular/core';
import { SubSink } from 'subsink';
import { SidebarHostDirective } from '../directives';
import { CoreService } from '../services';

@Component({
  selector: 'app-menu-switch',
  template: ` <ng-template appSidebarHost></ng-template> `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSwitchComponent implements OnInit, OnDestroy {
  @ViewChild(SidebarHostDirective, { static: true })
  appSidebarHost!: SidebarHostDirective;
  @HostBinding('class') class = 'd-flex flex-column flex-grow-1';
  private subs = new SubSink();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private coreSvc: CoreService
  ) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    const viewContainerRef = this.appSidebarHost.viewContainerRef;
    this.subs.sink = this.coreSvc.sidebarMenu$.subscribe((sidebar) => {
      viewContainerRef.clear();
      const componentFactory =
        this.componentFactoryResolver.resolveComponentFactory(sidebar);
      const componentRef =
        viewContainerRef.createComponent<any>(componentFactory);
      //componentRef.instance.data = adItem.data;
      componentRef.changeDetectorRef.detectChanges();
    });
  }
}
